import Vue from 'vue';
import App from '@/contacts-listing/App.vue';
// import Router from '@/myapp/router';
import Store from '@/contacts-listing/store';
import Blue from '../js/core';

Vue.config.devtools = true;
Vue.config.productionTip = false;

new Blue(
  {
    name: 'ContactsListingApp',
    selector: '#contacts-listing-member-app',
    setup(el) {
      const app = new Vue({
        store: el.dataset.listingDisplay == "grid" ? new Store().store : null,
        data: () => Object.assign({}, el.dataset),
        render: h => h(App),
      });
      app.$mount(el);
    },
  },
  false
);